module.exports = __webpack_public_path__ + "static/media/tajikistan-small.e0185189.jpg";